import { Copy, Check } from 'lucide-react';
import { DEVICE_LINKING } from '../../constants/device-linking';

type Props = {
  linkCode: string;
  copied: boolean;
  onCopy: () => void;
};

export default function LinkCodeDisplay({ linkCode, copied, onCopy }: Props) {
  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <div className="flex-1 p-3 sm:p-4 bg-white border-2 border-green-500 rounded-lg">
        <div className="text-base text-gray-600 mb-1">
          Your Link Code
        </div>
        <div className="text-2xl sm:text-3xl font-bold text-green-700 font-mono tracking-wider break-all">
          {linkCode}
        </div>
        <div className="text-xs text-gray-500 mt-1">
          Expires in {DEVICE_LINKING.CODE_EXPIRY_MINUTES} minutes
        </div>
      </div>
      <button
        onClick={onCopy}
        className="p-3 bg-green-700 text-white rounded-lg hover:bg-green-800 transition-colors flex-shrink-0 self-center sm:self-auto"
        title="Copy code">
        {copied ? <Check className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
      </button>
    </div>
  );
}
